import React from 'react';
import { $ } from '../lib/ext-refs';
import { toLabel } from '../lib/utils';
import {formatAmount} from '../lib/payment-utils';
import { header } from 'express-validator/check';
import axios from "axios";

class LiabilitySummaryWidget extends React.Component {


    constructor(props) {
        super(props);
    }

    async componentDidMount() {
        const { state } = this.props
        const { config, data } = state;
        const selectedAccounts = data.selectedAccounts || [];
        // if more than one account is selected then do not get liability info for widget since widget will not be displayed
        if(selectedAccounts.length > 1){
            state.setValue('widgetInfo', null);
        }
        const account = selectedAccounts[0];
        if(!account){
            state.setValue('widgetInfo', null);
        }

        try{
            let response = await this.sendRequest({
                url: `./xotp-api/accounts/${config.tla}`,
                method: "GET",
                params: {
                    'JWT_TOKEN': config.nginxJwtToken,
                    'account-number': account.accountNumber,
                    'payment-type-code': account.paymentTypeCode,
                    'api-internal': true,
                    'skip-auth-token-validation': true,
                    'include-schedules' : true
                },
                headers: {
                    'Authorization': `Bearer ${config.nginxJwtToken}`
                },
            });
            let data = response.data['account-info-response'];
            if (data['validation-status'] === 'FAILED'){
                state.setValue('widgetInfo', null);
                return;
            }
            this.populateWidget(data);
        }catch (e) {
            console.log(e)
            return null;
        }
    }

    populateWidget(data){
        const { state } = this.props
        state.setValue('widgetInfo', data);
    }

    async sendRequest(params) {
        return axios({
            ...params,
            url: params.url,
            headers: {
                "Content-type": "application/json",
                ...params.headers
            }
        });
    };

    render() {
        const { state, appComponents } = this.props,
            { formatAccountNumber } = appComponents;
        const { config, data } = state;
        const {messages, clientConfig} = config;
        const liabAccount= data.widgetInfo;
        if(!liabAccount){
            return("");
        }
        const customer = liabAccount.customer;

        return (
            <div className="summary-widget">
                <div id="current-bill-box" class="current-bill-container">
                    <div class="current-bill-titlebar">
                        <span class="current-bill-title">{messages['billSummary.header']}</span>
                    </div>
                    <div class="current-bill-content">
                        <table width="100%" border="0">
                            <tbody>
                                {   (customer.firstName || customer.lastName) &&
                                    <tr class="current-bill-row">
                                        <td valign="top" class="widget-table-label">
                                        {messages['name.label']}:&nbsp;
                                        </td>
                                        <td class="widget-table-data">
                                            {customer.firstName} {customer.lastName}
                                        </td>
                                    </tr>
                                }
                                    <tr class="current-bill-row">
                                        <td valign="top" class="widget-table-label">
                                            {messages['account.accountNumber.alt1.label']}:&nbsp;
                                        </td>
                                        <td class="widget-table-data">
                                            {formatAccountNumber(liabAccount['account-number'], liabAccount['default-payment-type-code'], clientConfig)}
                                        </td>
                                    </tr>
                                    <tr class="current-bill-row">
                                        <td valign="top" class="widget-table-label">
                                            {messages['serviceAddress.label']}:&nbsp;
                                        </td>
                                        <td class="widget-table-data">
                                            {customer.address.line1 ? customer.address.line1 : ''}<br />
                                            {customer.address.line2 ? customer.address.line2: ''}<br />
                                            {customer.address.city ? customer.address.city: ''}, {customer.address.state ? customer.address.state: ''}<br />
                                            {customer.address.zipCode ? customer.address.zipCode: ''}
                                        </td>
                                    </tr>
                                    {   liabAccount['date-due'] &&
                                        <tr class="current-bill-row">
                                            <td valign="top" class="widget-table-label">
                                                {messages['billSummary.dueDate.label'] || messages['payment.dueDate.label']}:&nbsp;
                                            </td>
                                            <td class="widget-table-data">
                                                {moment(liabAccount['date-due'], 'MMDDYYYY').format("MMM DD, YYYY")}
                                            </td>
                                        </tr>
                                    }
                                    { liabAccount['amount-past-due'] > 0 &&
                                        <tr class="current-bill-row">
                                            <td valign="top" class="widget-table-label">
                                                {messages['payment.pastDueAmount.label']}:&nbsp;
                                            </td>
                                            <td class="widget-table-data">
                                                ${liabAccount.amountPastDue};
                                            </td>
                                        </tr>
                                    }
                                    { liabAccount['amount-past-due'] > 0 &&
                                        <tr class="current-bill-row">
                                            <td valign="top" class="widget-table-label">
                                                {messages['payment.currentDueAmount.label']}:&nbsp;
                                            </td>
                                            <td class="widget-table-data">
                                                ${liabAccount['amount-due'] - liabAccount['amount-past-due']};
                                            </td>
                                        </tr>
                                    }
                                    { liabAccount['amount-due'] >= 0 &&
                                        <tr class="current-bill-row">
                                            <td valign="top" class="widget-table-label">
                                                {messages['totalAmountDue.label']}:&nbsp;
                                            </td>
                                            <td class="widget-table-data">
                                                {formatAmount(liabAccount['amount-due'])}
                                            </td>
                                        </tr>
                                    }
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        )
    }
}
export {
    LiabilitySummaryWidget
} 